<!-- ===================== CONTACTO ===================== -->
<section class="contact" id="contacto">
  <div class="contact-head">
    <span class="eyebrow">{{ 'contacto.eyebrow' | translate }}</span>
    <h1 class="section-title" [innerHTML]="'contacto.titleHtml' | translate"></h1>
    <p class="section-lead center">{{ 'contacto.lead' | translate }}</p>
  </div>

  <div class="office" *ngFor="let o of offices" [class.reverse]="o.reverse">
    <div class="office-map">
      <iframe [src]="o.map" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
    <div class="office-info">
      <span class="office-label">{{ o.labelKey | translate }}</span>
      <h3>{{ o.name }}</h3>
      <div class="info-cols">
        <div>
          <h4>{{ 'contacto.lblContact' | translate }}</h4>
          <div class="info-group">
            <span class="lbl">{{ 'contacto.lblAddress' | translate }}</span>
            <p *ngFor="let line of o.address">{{ line }}</p>
          </div>
          <div class="info-group">
            <span class="lbl">{{ 'contacto.lblEmail' | translate }}</span>
            <p>{{ 'contacto.infoPrefix' | translate }} {{ o.infoEmail }}</p>
            <p>{{ 'contacto.supportPrefix' | translate }} {{ o.supportEmail }}</p>
          </div>
          <div class="info-group">
            <span class="lbl">{{ 'contacto.lblPhone' | translate }}</span>
            <p>{{ 'contacto.infoPrefix' | translate }} {{ o.infoPhone }}</p>
            <p>{{ 'contacto.supportPrefix' | translate }} {{ o.supportPhone }}</p>
          </div>
        </div>
        <div>
          <h4>{{ 'contacto.lblHours' | translate }}</h4>
          <div class="info-group">
            <span class="lbl">{{ 'contacto.lblWeekdays' | translate }}</span>
            <p>{{ o.hours }}</p>
          </div>
          <div class="info-group">
            <span class="lbl">{{ 'contacto.lblSat' | translate }}</span>
            <p>{{ 'contacto.closed' | translate }}</p>
          </div>
          <div class="info-group">
            <span class="lbl">{{ 'contacto.lblSun' | translate }}</span>
            <p>{{ 'contacto.closed' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
